{
  "title": "Time Stop",
  "source": "Player's Handbook",
  "levelAndSchool": "9th-level transmutation",
  "level": 9,
  "castingTime": "1 action",
  "range": "Self",
  "components": "V",
  "duration": "Instantaneous",
  "description": [
    "You briefly stop the flow of time for everyone but yourself. No time passes for other creatures, while you take 1d4 + 1 turns in a row, during which you can use actions and move as normal.",
    "This spell ends if one of the actions you use during this period, or any effects that you create during this period, affects a creature other than you or an object being worn or carried by someone other than you. In addition, the spell ends if you move to a place more than 1,000 feet from the location where you cast it."
  ],
  "spellLists": ["sorcerer", "wizard"]
}
